import React from "react";
import "../../styles/Contact.scss"; // Adjust the path as needed

function Contact() {
    return (
        <div className="contact">
            <h2>
                charliejsimons@gmail.com<br></br> OR <br></br> csimons4@uvm.edu
            </h2>
        </div>
    );
}

export default Contact;